import { render, staticRenderFns } from "./Moxingkulistguanli.vue?vue&type=template&id=ba05603c&scoped=true&"
import script from "./Moxingkulistguanli.vue?vue&type=script&lang=js&"
export * from "./Moxingkulistguanli.vue?vue&type=script&lang=js&"
import style0 from "./Moxingkulistguanli.vue?vue&type=style&index=0&id=ba05603c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba05603c",
  null
  
)

export default component.exports